import Wrapper from "../../layout/Wrapper";
import LegacyLifeBillApprove from "../../screens/legacyLifeEntry/billApprove";
import LegacyShell from "../../screens/legacyLifeEntry/shell";

export default function LegacyLifeBillApprovePage() {
  return <Wrapper><LegacyShell><LegacyLifeBillApprove /></LegacyShell></Wrapper>;
}
